export default {"src":"/_next/static/media/icon-logo.758971e5.svg","height":40,"width":66,"blurWidth":0,"blurHeight":0};